import { availabilityWindow } from './availability-window'
import { configAlerts } from './config-alerts'
import { insights } from './insights'
import { limits } from './limits'
import { metrics } from './metrics'
import { missionSpecialist } from './mission-specialist'
import { ontology } from './ontology'
import { overview } from './overview'
import { pipeline } from './pipeline'
import { recycler } from './recycler'
import { requalification } from './requalification'
import { stats } from './stats'
import { timezone } from './timezone'
import { trainingModules } from './training-modules'
import * as A from './useAudit'
import { useGetSoftwareVersions } from './useGetSoftwareVersions'
import { useGetSystemIds } from './useGetSystemIds'
import { useGetProgramSummary } from './useGetUserSummary'
import * as P from './useProgram'

export type {
  Program,
  ProgramInstanceCatalogItem,
  ProgramListItem,
  ProgramWithBasicInformation,
  UpdateProgramRequest,
} from './useProgram'
export type {
  ProgramInstanceSpecialistRow,
  ProgramInstanceSpecialistsOrderBy,
  ProgramInstanceSpecialistsResponse,
} from './mission-specialist/useGetReport'
export type { ProgramInstanceTaskCompletionResponse } from './stats/useGetTaskCompletion'
export type { ProgramInstanceTaskOutcomeResponse } from './stats/useGetTaskOutcome'

export const programs = {
  create: P.useCreate,
  getById: P.useGetById,
  getInstancesCatalog: P.useGetProgramInstancesCatalog,
  getList: P.useGetList,
  getActiveList: P.useGetActivePrograms,
  getResponses: P.useGetResponses,
  getV2List: P.useGetV2List,
  update: P.useEdit,
  updateBasicInformation: P.useUpdateBasicInformation,
  updateResolutionTargets: P.useUpdateResolutionTargets,
  insights,
  trainingModules,
  ontology,
  pipeline,
  recycler,
  requalification,
  metrics,
  audit: {
    getById: A.useGetById,
    getVoiders: A.useGetVoiderList,
  },
  availabilityWindow,
  stats,
  missionSpecialist,
  overview,
  limits,
  configAlerts,
  timezone,
  autoEligibilityWork: P.useAutoEligibilityWork,
  reminder: P.useReminder,
  softwareVersions: useGetSoftwareVersions,
  resolutionAnnotationClasses: P.useGetResolutionAnnotationClasses,
  getSystemIds: useGetSystemIds,
  getUserSummary: useGetProgramSummary,
}
